<template>
  <v-form ref="form" @submit.prevent="$emit('submit-form')">
    <v-row>
      <v-col cols="12">
        <p>In order to <strong>protect your account</strong> make sure your password:</p>
        <ul>
          <li>Is at least 8 characters in length</li>
          <li>Is a mix of letters, numbers, and symbols</li>
          <li>Does not match your {{ usernameLabel }}</li>
        </ul>
      </v-col>
      <v-col v-if="requireExistingPassword" cols="12">
        <v-text-field
          :rules="[rules.required]"
          label="Current password"
          type="password"
          v-model="oldPassword"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          :rules="[
            rules.required,
            rules.minLength.bind(null, 8),
            mustContainLetters,
            mustContainNumbers,
            mustContainSpecialCharacters,
            cantMatchUserName
          ]"
          label="New password"
          type="password"
          v-model="newPassword"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          :rules="[rules.required, passwordsMustMatch]"
          label="Confirm new password"
          type="password"
          v-model="confirmNewPassword"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="!!$slots.default">
        <slot></slot>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { Rules } from './rules'

const PASSWORD_CONTAIN_MSG = 'Password must contain letters, numbers, and special characters'
export default {
  name: 'PasswordForm',
  props: {
    username: {
      type: String,
      description: 'the username of the user in context',
      default: null
    },
    usernameLabel: {
      type: String,
      description: 'the name of the username field. Typically username (default) or email',
      default: 'username'
    },
    requireExistingPassword: {
      type: Boolean,
      description: 'Determines if the users existing password must be entered',
      default: false
    }
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      rules: Rules
    }
  },
  methods: {
    passwordsMustMatch(value) {
      return (
        this.newPassword === null ||
        this.newPassword === undefined ||
        String(this.newPassword).trim() === '' ||
        value === null ||
        value === undefined ||
        String(value).trim() === '' ||
        this.newPassword === value ||
        'Password does not match.'
      )
    },
    mustContainLetters() {
      if (!this.newPassword) return true
      return /[a-zA-Z]/.test(this.newPassword) || PASSWORD_CONTAIN_MSG
    },
    mustContainNumbers() {
      if (!this.newPassword) return true
      return /[\d]/.test(this.newPassword) || PASSWORD_CONTAIN_MSG
    },
    mustContainSpecialCharacters() {
      if (!this.newPassword) return true
      return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.newPassword) || PASSWORD_CONTAIN_MSG
    },
    cantMatchUserName() {
      return (
        this.newPassword === null ||
        this.username != this.newPassword ||
        `Password cannot match your ${this.usernameLabel}`
      )
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    clear() {
      this.newPassword = null
      this.confirmNewPassword = null
      this.oldPassword = null
    }
  }
}
</script>
